import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '../../DataDisplay/Tooltip';
import {inputStyles} from './styles';
import {type InputWrapperProps} from './types';

function InputWrapper({
  children,
  label,
  labelVariant,
  tooltip,
  error,
  hideError,
  startSlot,
  endSlot,
  labelSlot,
  hideLabel,
  fullWidth = false,
  inline = false,
  hint = '',
  messageId,
}: InputWrapperProps) {
  // TODO(cboltt): Refactor to instead pass LabelProps
  const hasTypographyVariant = labelVariant !== 'bold' && labelVariant !== 'normal';

  return (
    <Box sx={inputStyles.root(fullWidth, inline)}>
      {!hideLabel && (
        <Box sx={inputStyles.labelArea}>
          <Box sx={inputStyles.label}>
            <Typography
              color="text.primary"
              fontWeight={labelVariant === 'bold' ? '600' : '500'}
              variant={hasTypographyVariant ? labelVariant : undefined}
              mr={1}
            >
              {label}
            </Typography>
            {tooltip && (
              <Tooltip
                title={tooltip}
                focusable
                ariaLabel={label ? `More information about ${label}` : 'More information'}
              >
                <InfoOutlinedIcon fontSize="inherit" sx={{mb: -0.25}} />
              </Tooltip>
            )}
          </Box>
          {labelSlot}
        </Box>
      )}
      {startSlot && <Box sx={inputStyles.startSlotArea}>{startSlot}</Box>}
      <Box sx={inputStyles.inputArea}>{children}</Box>
      {endSlot && <Box sx={inputStyles.endSlotArea}>{endSlot}</Box>}
      {!hideError && (
        <Typography id={messageId} variant="body2" sx={inputStyles.errorArea(!!error)}>
          {error || hint}
        </Typography>
      )}
    </Box>
  );
}

export default InputWrapper;
